<template>
  <el-table v-loading="isLoading" min-width="500px" :data="users" class="table-responsive table-striped" header-row-class-name="thead-light">
    <el-table-column label="Nome" min-width="200px" prop="name" sortable />
    <el-table-column label="E-mail" min-width="210px" prop="email" sortable />
    <el-table-column label="Papel" min-width="120px" prop="role.name" sortable />
    <el-table-column label="Status" min-width="116px" prop="status" v-slot="{ row }" sortable>
      <badge class="badge-dot mr-4" type v-if="row.status === true">
        <i class="bg-success"></i>Ativo
      </badge>
      <badge class="badge-dot mr-4" type v-else>
        <i class="bg-danger"></i>Inativo
      </badge>
    </el-table-column>

    <el-table-column label="Ações" min-width="95px" prop="acoes" v-slot="{ row }">
      <el-dropdown trigger="hover" class="dropdown" style="cursor: pointer;">
        <span class="btn btn-sm btn-icon-only text-success">
          <i class="fas fa-ellipsis-v mt-2"></i>
        </span>
        <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
          <a class="dropdown-item" href="#" @click="emit('view', row)">Visualizar</a>
          <a class="dropdown-item" href="#" @click="emit('edit', row)">Editar</a>
          <a class="dropdown-item" href="#" @click="emit('remove', row)">Excluir</a>
        </el-dropdown-menu>
      </el-dropdown>
    </el-table-column>
  </el-table>
</template>

<script setup>
import {
  Table,
  TableColumn,
  DropdownMenu,
  Dropdown,
} from "element-ui";

const ElTable = Table
const ElTableColumn = TableColumn
const ElDropdownMenu = DropdownMenu
const ElDropdown = Dropdown

const props = defineProps({
  isLoading: {
    type: Boolean,
    required: true
  },
  users: {
    type: Array,
    required: true
  }
})

const emit = defineEmits(['view', 'edit', 'remove'])

</script>
